export const SESSION_STATUSES = {
  ACCEPTED: "accepted",
  COMPLETED: "completed",
  CANCELED_BY_CLIENT: "canceled_by_client",
  CANCELED_BY_COACH: "canceled_by_coach",
  CANCELED_BY_HUMANOO: "canceled_by_humanoo"
};

export const PARTNER_AFFILIATIONS = {
  NOT_AFFILIATED: "not_affiliated",
  SOLIDARIS: "solidaris",
  COHEZIO: "cohezio"
};

export const PAYMENT_STATUSES = {
  NOT_VALIDATED: "not_validated",
  PAID_VIA_LINK: "paid_via_link",
  PAID_VIA_VOUCHER: "paid_via_voucher",
  NOT_PAID: "not_paid"
};
